import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
export var filterProps = function filterProps(props, filterFn) {
  return Object.entries(props).filter(function (_ref) {
    var key = _ref[0];
    return filterFn(key);
  }).reduce(function (result, _ref2) {
    var _objectSpread2;

    var key = _ref2[0],
        value = _ref2[1];
    return _objectSpread(_objectSpread({}, result), {}, (_objectSpread2 = {}, _objectSpread2[key] = value, _objectSpread2));
  }, {});
};
export var modifyProps = function modifyProps(props, modifyFn) {
  return Object.keys(props).reduce(function (acc, key) {
    var _objectSpread3;

    return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread3 = {}, _objectSpread3[key] = modifyFn(props[key]), _objectSpread3));
  }, {});
};
export var splitProps = function splitProps(props, keys) {
  var includedKeys = filterProps(props, function (key) {
    return keys.includes(key);
  });
  var excludedKeys = filterProps(props, function (key) {
    return !keys.includes(key);
  });
  return [includedKeys, excludedKeys];
};